(() => {
if(window.s2tUvCarouselsLoaded) return;
window.s2tUvCarouselsLoaded = true;
/* Progressive enhancement: native overflow/swipe remains available without JS. */
const init = (root = document) => root.querySelectorAll('.s2t-uv [data-carousel]').forEach((carousel) => {
  if(carousel.dataset.enhanced !== undefined) return;
  const track = carousel.querySelector('[role="list"]');
  const cards = [...track.children];
  const prev = carousel.querySelector('[data-prev]');
  const next = carousel.querySelector('[data-next]');
  const status = carousel.querySelector('[data-status]');
  if (!cards.length) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const step = () => cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
  const visibleCount = () => Math.max(1, Math.floor((track.clientWidth + parseFloat(getComputedStyle(track).columnGap)) / step()));
  const move = (direction, oneCard = false) => track.scrollBy({ left: direction * step() * (oneCard ? 1 : visibleCount()), behavior: reducedMotion.matches ? 'instant' : 'smooth' });
  const update = () => {
    const first = Math.max(0, Math.round(track.scrollLeft / step()));
    const last = Math.min(cards.length, first + visibleCount());
    prev.disabled = track.scrollLeft < 2;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    status.textContent = `${first + 1 === last ? last : `${first + 1}–${last}`} of ${cards.length} designs`;
  };
  prev.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  track.addEventListener('keydown', (event) => {
    if (event.target !== track) return;
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1, true);
    } else if (event.key === 'Home' || event.key === 'End') {
      event.preventDefault();track.scrollTo({left:event.key==='Home'?0:track.scrollWidth,behavior:reducedMotion.matches?'instant':'smooth'});
    }
  });
  let timer;
  track.addEventListener('scroll', () => { clearTimeout(timer); timer = setTimeout(update, 100); }, {passive:true});
  const observer = new ResizeObserver(update);
  observer.observe(track);
  const unload = (event) => { if(event.target.contains(carousel)) { observer.disconnect(); clearTimeout(timer); document.removeEventListener('shopify:section:unload',unload); } };
  document.addEventListener('shopify:section:unload',unload);
  carousel.dataset.enhanced = '';
  update();
});

init();
document.addEventListener('shopify:section:load',event=>init(event.target));
})();
